import { apiGet } from "@/lib/http/client";

export interface ExportDownloadUrlResponse {
  file_id: number;
  file_name: string;
  download_url: string;
  expires_at: string;
}

export function getExportDownloadUrl(jobId: string, fileId: number) {
  return apiGet<ExportDownloadUrlResponse>(
    `/export-jobs/${encodeURIComponent(jobId)}/files/${fileId}/download-url`,
  );
}
